import classnames from 'classnames';
import {formatPaymentMethod} from '@ppcp/utils';
import {useProcessFastlaneToken, useManageFastlaneToken} from "./hooks";
import {TokenizedPaymentMethod} from "../../components";

export default function FastlaneTokenizedCard(
    {
        data,
        token,
        fastlane,
        customerFound,
        ...props
    }) {

    const {
        i18n,
        icons,
        payment_format
    } = data;

    const {
        cartData,
        emitResponse,
        eventRegistration,
        shouldSavePayment
    } = props;

    const {
        onPaymentSetup
    } = eventRegistration;

    const {
        extensions
    } = cartData;

    const needsSetupToken = extensions?.wc_ppcp?.needsSetupToken || false;

    let {
        card
    } = token.paymentSource;

    card = {
        ...card,
        brand: card.brand,
        last4: card.lastDigits,
        expiry: card.expiry
    };

    useProcessFastlaneToken({
        token,
        emitResponse,
        onPaymentSetup,
        needsSetupToken,
        shouldSavePayment
    });

    const {
        onCancel,
        onChangePaymentMethod
    } = useManageFastlaneToken({
        fastlane
    });

    const actions = [
        {
            type: 'cancel',
            onClick: onCancel,
            label: i18n.cancel
        }
    ];

    if (customerFound) {
        actions.push({
            type: 'change',
            onClick: onChangePaymentMethod,
            label: i18n.change
        });
    }

    return (
        <TokenizedPaymentMethod
            className={classnames({'has-customer-context': customerFound})}
            icon={{
                alt: card.brand,
                src: icons[card.brand.toLowerCase()]
            }}
            description={formatPaymentMethod(payment_format, card)}
            actions={actions}/>
    )
}